export * from './workspace-mfa-requirement';
export const WORKSPACE_NAME_MIN_LENGTH = 3;
export const WORKSPACE_NAME_MAX_LENGTH = 30;
export { NAME_CONTENT_REGEX as WORKSPACE_NAME_CONTENT_REGEX, NAME_END_REGEX as WORKSPACE_NAME_END_REGEX, NAME_OPENAPI_REGEX as WORKSPACE_NAME_OPENAPI_REGEX, NAME_START_REGEX as WORKSPACE_NAME_START_REGEX, } from '#validation/common/constants';
export var WorkspaceLoginConfigQueryType;
(function (WorkspaceLoginConfigQueryType) {
    WorkspaceLoginConfigQueryType["ID"] = "id";
    WorkspaceLoginConfigQueryType["NAME"] = "name";
})(WorkspaceLoginConfigQueryType || (WorkspaceLoginConfigQueryType = {}));
export var WorkspaceStatus;
(function (WorkspaceStatus) {
    WorkspaceStatus["SUSPENDED"] = "suspended";
    WorkspaceStatus["ACTIVE"] = "active";
    WorkspaceStatus["TRIALING"] = "trialing";
})(WorkspaceStatus || (WorkspaceStatus = {}));
export var WorkspaceSuspensionReason;
(function (WorkspaceSuspensionReason) {
    WorkspaceSuspensionReason["TRIAL_OVER"] = "trialOver";
    WorkspaceSuspensionReason["MANUAL_SUSPENSION"] = "manualSuspension";
    WorkspaceSuspensionReason["AWS_CONTRACT_CANCELLED"] = "awsContractCancelled";
    WorkspaceSuspensionReason["BILLING_PAST_DUE"] = "billingPastDue";
})(WorkspaceSuspensionReason || (WorkspaceSuspensionReason = {}));
export var WorkspaceDomainStatus;
(function (WorkspaceDomainStatus) {
    WorkspaceDomainStatus["UNVERIFIED"] = "unverified";
    WorkspaceDomainStatus["PENDING"] = "pending";
    WorkspaceDomainStatus["VERIFIED"] = "verified";
    WorkspaceDomainStatus["UNAVAILABLE"] = "unavailable";
    WorkspaceDomainStatus["WAITING_FOR_KEY_IMPORT"] = "waitingForKeyImport";
})(WorkspaceDomainStatus || (WorkspaceDomainStatus = {}));
